"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var constant_1 = require("../../constant");
var utils_1 = require("../../style/utils");
var variables_1 = require("../../style/variables");
var data_display_1 = require("../data-display");
var layout_1 = require("../layout");
var Text_1 = __importDefault(require("../Text"));
var constants_1 = require("./constants");
var context_1 = require("./context");
var Tooltip_1 = __importDefault(require("../Tooltip"));
var icons_1 = require("../../icons");
var headerStyle = function (theme, size, divider) {
    return react_1.css(__assign({ borderBottom: divider ? theme.border : undefined }, (theme.name === constant_1.DESIGN_SYSTEM
        ? {
            padding: constants_1.SIZE_TO_PADDING[size],
        }
        : {
            padding: '20px 30px',
        })));
};
var CardHeader = function (_a) {
    var title = _a.title, infoText = _a.infoText, subTitle = _a.subTitle, tabs = _a.tabs, leadingType = _a.leadingType, avatarProps = _a.avatarProps, iconProps = _a.iconProps, actions = _a.actions, children = _a.children, _b = _a.divider, divider = _b === void 0 ? true : _b, props = __rest(_a, ["title", "infoText", "subTitle", "tabs", "leadingType", "avatarProps", "iconProps", "actions", "children", "divider"]);
    var theme = react_1.useTheme();
    var size = react_2.useContext(context_1.CardContext).size;
    var style = react_2.useMemo(function () { return headerStyle(theme, size, divider); }, [theme, size, divider]);
    // To not break old usages, only use the new strutured header if any of the props for it are
    // provided.
    var useNewStructure = (title || subTitle || tabs || leadingType || avatarProps || iconProps || actions);
    var leadingSize = 'md';
    if (size === 'md') {
        leadingSize = 'lg';
    }
    if (size === 'lg') {
        leadingSize = 'xl';
    }
    var avatar = leadingType === 'avatar' && avatarProps ? (react_1.jsx(data_display_1.Avatar, __assign({ size: leadingSize }, avatarProps))) : null;
    var icon = leadingType === 'icon' && iconProps ? (react_1.jsx(data_display_1.FeaturedIcon, __assign({ size: leadingSize }, iconProps))) : null;
    return useNewStructure ? (react_1.jsx(layout_1.Flex, { direction: "column", gap: 16, css: style },
        react_1.jsx(layout_1.Flex, { gap: 16 },
            react_1.jsx(layout_1.Flex, { gap: 16, alignItems: "center", css: { flex: 1 } },
                avatar,
                icon,
                react_1.jsx(layout_1.Flex, { direction: "column", css: { flex: 1 }, gap: 2 },
                    title || infoText ? (react_1.jsx(layout_1.Flex, { gap: 4, alignItems: "center" },
                        react_1.jsx(Title, null, title),
                        infoText ? (react_1.jsx(Tooltip_1.default, { overlay: infoText },
                            react_1.jsx(icons_1.InfoCircle, { color: "var(" + variables_1.RootColor.Gray.DEFAULT + ")", size: 16 }))) : null)) : null,
                    subTitle ? react_1.jsx(Subtitle, null, subTitle) : null)),
            actions ? (react_1.jsx(layout_1.Flex, { gap: 8, alignItems: "flex-start" }, actions)) : null),
        children,
        tabs ? (react_1.jsx(layout_1.Flex, { css: { marginBottom: -17 } }, tabs)) : null)) : (react_1.jsx("div", __assign({ css: style }, props), children));
};
var titleStyle = react_1.css({
    fontSize: utils_1.pxToRem(14),
    lineHeight: 1.4,
    fontWeight: 600,
    textTransform: 'uppercase',
    color: '#001f32',
});
var Title = function (props) {
    var theme = react_1.useTheme();
    var size = react_2.useContext(context_1.CardContext).size;
    var titleSize;
    if (size === 'md') {
        titleSize = 'lg';
    }
    if (size === 'lg') {
        titleSize = 'xl';
    }
    return theme.name === constant_1.DESIGN_SYSTEM ? (react_1.jsx(Text_1.default.Title, { size: titleSize, color: "var(" + variables_1.TextColor.HEAD + ")" }, props.children)) : (react_1.jsx("span", __assign({ css: titleStyle }, props)));
};
var subtitleStyle = react_1.css({
    fontSize: utils_1.pxToRem(12),
    lineHeight: 1.4,
    color: '#505C62',
});
var Subtitle = function (props) {
    var theme = react_1.useTheme();
    return theme.name === constant_1.DESIGN_SYSTEM ? (react_1.jsx(Text_1.default.Body, { color: "var(" + variables_1.TextColor.DEFAULT + ")" }, props.children)) : (react_1.jsx("span", __assign({ css: subtitleStyle }, props)));
};
exports.default = Object.assign(CardHeader, { Title: Title, Subtitle: Subtitle });
